import { combineReducers } from "redux";
import ponies from "./ponies";

const rootReducer = combineReducers({
  ponies
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js